var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hotel-gallery-form"},[_c('custom-uploader',{attrs:{"multiple":true,"media-objects":_vm.currentMedia},model:{value:(_vm.newUploads),callback:function ($$v) {_vm.newUploads=$$v},expression:"newUploads"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }